import axios from 'axios';
import { BASE_URL } from './../../Api/ApiUrls';

export const checkPropertyUploadLimit = async (userId, userType, propertyType) => {
  try {
    const res = await axios.get(`${BASE_URL}/users/${userId}/`);
    const user = res.data;

    const now = new Date();

    // 🔹 Active subscription for selected user type
    const activeSub = user.user_sub_plan?.find(
      sub =>
        sub.user_type === userType &&
        sub.status === true &&
        new Date(sub.expired_date) > now
    );

    if (!activeSub) {
      return {
        canUpload: false,
        message: 'No active subscription found',
      };
    }

    // 🔹 Base limit
    let allowed = activeSub.no_of_properties_unlimited
      ? Infinity
      : activeSub.no_of_properties || 0;

    // 🔹 Add addon limits
    const addons = user.user_addon_plan?.filter(
      addon => addon.extend_to === activeSub.sub_id
    ) || [];

    addons.forEach(addon => {
      if (addon.no_of_properties_unlimited) {
        allowed = Infinity;
      } else {
        allowed += addon.no_of_properties || 0;
      }
    });

    // 🔹 Count already uploaded properties
    const used = user.user_properties?.filter(
      p => p.type === propertyType && p.posted_by === (
        userType === 'Agent' ? 'Agent' : 'Owner'
      )
    ).length || 0;

    if (used >= allowed) {
      return {
        canUpload: false,
        message: `Upload limit reached (${allowed})`,
        used,
        allowed,
        remaining: 0
      };
    }

    return {
      canUpload: true,
      used,
      allowed,
      remaining: allowed === Infinity ? 'Unlimited' : allowed - used
    };
  } catch (err) {
    console.error('Limit check failed:', err);
    return {
      canUpload: false,
      message: 'Unable to verify subscription'
    };
  }
};
